var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "container mt-5"
  }, [_c('div', {
    staticClass: "text-center mt-3"
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))])]), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mb-1 mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 回官方帳號 ")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }